import React, { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Header } from '../components/Header';
import { NavButtons } from '../components/navButtons';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInitialSiteInfo } from '../store/financialSlice';
import { fetchChargersStatus } from '../store/chargerSlice';
import { SiteSelect } from '../components/SiteSelect/SiteSelect';
import { ReactComponent as EvcIcon } from '../images/roam_map_marker_red.svg';
import { ReactComponent as NcpIcon } from '../images/NCPLOGO.svg';
import { fetchInitialUptimeData } from '../store/healthSlice';
import ThemeSelector from '../components/themeSelector';

const Portal = () => {
  const dispatch = useDispatch();
  const { themeSelect } = useSelector((state) => state.user);
  const location = useLocation();

  const updateChargerStatus = useCallback(() => {
    dispatch(fetchChargersStatus());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchInitialSiteInfo());
    dispatch(fetchChargersStatus());
    dispatch(fetchInitialUptimeData());
  }, [dispatch]);

  useEffect(() => {
    const intervalId = setInterval(updateChargerStatus, 60000);

    return () => {
      clearInterval(intervalId);
    };
  }, [updateChargerStatus]);

  const selectedTheme = themeSelect === 'NCP' ? <NcpIcon /> : <EvcIcon />;
  const isDev = process.env.REACT_APP_ENV !== 'prod';

  const hideSiteSelectRoutes = ['/portal-access', '/statements'];

  return (
    <div className="flex overflow-x-clip">
      {isDev && (
        <div className="absolute right-2 top-2 group">
          <div className="invisible group-hover:visible">
            <ThemeSelector />
          </div>
        </div>
      )}

      <div className="flex-shrink-0 w-[80px] bg-side-bar-color min-h-screen">
        <div className="pt-16 mr-[-18px]">{selectedTheme}</div>
      </div>

      <div className="flex flex-col w-full">
        <Header />
        <NavButtons />
        <div className="flex w-full pr-10 ">
          <div className={`w-2/6 ${hideSiteSelectRoutes.includes(location.pathname) ? 'hidden' : 'visible'}`}>
            <SiteSelect />
          </div>
          <div className="w-full overflow-y-scroll h-full">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portal;
